<div *ngIf="loading === false && fileDummy && fileDummy.colorSet" class="position-relative"
     style="width: 100%;display: flex;height: 100%;flex-direction: column;justify-content: center;">
  <ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="resolveThumbnailPreview()">
      <div [style.height.px]="resolveSize('height')" [style.width.px]="resolveSize('width')"
           style="position: relative;">
        <img [alt]="draggedObj.fileName"
             [src]="castThumbnailToString(draggedObj.thumbnail)"
             style="object-fit: cover; width: 100%; height: 100%; clip-path: url(#file-clip); filter: opacity(0.4);"/>
        <div [style.border-bottom]="resolveWrinklesSizes() + 'px solid #ffffff'"
             [style.border-right]="resolveWrinklesSizes() + 'px solid transparent'"
             style="position: absolute; top: 0; right: 2px; width: 0; filter: drop-shadow(-3px 3px 3px rgba(0,0,0,0.14));height: 0; border-left: 0 solid transparent;"></div>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div [style.height.px]="resolveSize('height')" [style.width.px]="resolveSize('width')">
        <svg style="width: 100%; height: 100%;" viewBox="0 0 153 200" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient [attr.id]="'grad1' + id" x1="0%" x2="0%" y1="0%" y2="100%">
              <stop [style.stop-color]="fileDummy.colorSet.baseColor" offset="0%" style="stop-opacity:1"/>
              <stop [style.stop-color]="fileDummy.colorSet.gradientColor" offset="100%" style="stop-opacity:1"/>
            </linearGradient>
            <linearGradient [attr.id]="'grad2' + id" x1="0%" x2="0%" y1="0%" y2="100%">
              <stop [style.stop-color]="fileDummy.colorSet.baseColor" offset="0%" style="stop-opacity:1"/>
              <stop [style.stop-color]="fileDummy.colorSet.gradientColor" offset="100%" style="stop-opacity:1"/>
            </linearGradient>
          </defs>
          <g transform="translate(0,0)">
            <path
              [attr.fill]="'url(#grad1' + id + ')'"
              d="m7.99174,0.55703c-1.96832,0 -3.75471,0.7988 -5.04739,2.09148c-1.2926,1.2926 -2.0914,3.07907 -2.0914,5.04731l0,185.60837c0,1.96833 0.7988,3.75471 2.0914,5.04739c1.29267,1.29259 3.07906,2.0914 5.04739,2.0914l138.01652,0c1.96826,0 3.75472,-0.7988 5.04732,-2.0914c1.29259,-1.29268 2.09148,-3.07906 2.09148,-5.04739l0,-143.18469c0,-1.90553 -0.74365,-3.69829 -2.09148,-5.04731l-42.42369,-42.42369c-1.34784,-1.34901 -3.13965,-2.09148 -5.04738,-2.09148l-95.59277,0z"/>
            <path [attr.fill]="'url(#grad2' + id + ')'"
                  d="m108.97985,3.15376l0,40.02236c0,0.66551 0.27051,1.26926 0.70701,1.70616c0.43649,0.43649 1.04032,0.70701 1.70607,0.70701l40.02236,0l-42.43544,-42.43553z"
                  style="filter: drop-shadow(-3px 3px 3px rgba(0,0,0,0.14));"/>

          </g>
        </svg>
      </div>


    </ng-container>

  </ng-container>

  <div *ngIf="fileDummy" [style.color]="fileDummy.colorSet.fillColor" class="position-absolute"
       style="display: flex;width: 100%;font-size: 2rem;flex-direction: column;align-items: center;">
    <sb-icon [hover]="hover" [icon]="fileDummy.icon.name"></sb-icon>
    <p [style.color]="fileDummy.colorSet.fillColor" class="m-0 font-weight-bold"
       style="font-size: 1rem">{{fileDummy.fileName}}</p>
  </div>
</div>

<svg height="0" style="display: block;" width="0">
  <defs>
    <clipPath clipPathUnits="objectBoundingBox" id="file-clip">
      <path
        d="m0.052,0.003 c-0.013,0,-0.025,0.004,-0.033,0.01 c-0.008,0.006,-0.014,0.015,-0.014,0.025 l0,0.929 c0,0.01,0.005,0.019,0.014,0.025 c0.008,0.006,0.02,0.01,0.033,0.01 l0.906,0 c0.013,0,0.025,-0.004,0.033,-0.01 c0.008,-0.006,0.014,-0.015,0.014,-0.025 l0,-0.716 c0,-0.01,-0.005,-0.019,-0.014,-0.025 l-0.279,-0.212 c-0.009,-0.007,-0.021,-0.01,-0.033,-0.01 l-0.628,0"></path>
    </clipPath>
  </defs>
</svg>
